<template>
  <div class="common">
    <div class="common-top">
      <!-- <img src="../assets/feilan.png" alt="" class="common-top-avatar" /> -->
       <!-- <div class="common-top-title">杭州笑口杏信息科技有限公司</div> -->
       <div class="common-top-title">笑口杏</div>
      <div class="common-top-header">
        <div class="common-top-header-left">
          <div class="tab-container" v-if="logon && logon.userType != 3">
            <div
              v-for="(item, index) in headerList"
              :key="index"
              class="tab-item"
              @click="handleLink(item.path, index)"
            >
              <span>{{ item.label }}</span>
              <div class="tab-underline" v-if="activeName == index"></div>
            </div>
          </div>
            <div class="tab-container" v-if="logon && logon.userType == 3">
            <div
              v-for="(item, index) in adminList"
              :key="index"
              class="tab-item"
              @click="handleLink(item.path, index)"
            >
              <span>{{ item.label }}</span>
              <div class="tab-underline" v-if="activeName == index"></div>
            </div>
          </div>
        </div>
        <div class="common-top-header-right">
          <div
            class="common-top-header-right-bottom bottom2"
            @click="handlePublish"
          >
            发布项目
          </div>
          <div
            class="common-top-header-right-bottom bottom1"
            @click="handleLogin"
            v-if="!isLoad"
          >
            登录
          </div>
          <div
            class="common-top-header-right-user"
            v-else
            @mouseenter="showElement"
            @mouseleave="hideElement"
          >
            <img src="../assets/default.png" alt="" class="avatar" />
            <div class="count">
              <p>账号：</p>
              {{ logon.userName }}
            </div>
            <img
              src="../assets/down_arrow.png"
              alt=""
              style="width: 16px; height: 16px"
            />
            <div class="common-top-header-right-user-toptip" v-if="show">
              <p @click="handleLink('/mine')">我发布的</p>
              <span @click="handleLogout">退出登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <KeepAlive>
      <router-view />
    </KeepAlive>
    <!-- 重写后的footer，1:1匹配设计图 -->
    <div class="common-footer">
      <!-- 核心内容区：logo+联系方式 左右布局 -->
      <div class="footer-main">
        <!-- 左侧logo区域 -->
        <div class="footer-logo">
          <!-- <img
            src="../assets/feilan.png"
            alt="笑口杏信息科技"
            class="footer-logo-img"
          /> -->
          <!-- <div class="footer-logo-text">
            <h2>笑口杏信息科技</h2>
            <p>Hangzhou Zhenxuan Technology</p>
          </div> -->
        </div>
        <!-- 右侧联系方式 -->
        <div class="footer-contact">
          <h3>联系方式</h3>
          <p>电话：13071878930</p>
          <!-- <p>邮箱：contact@feilanwang.com</p> -->
          <p>
            地址：浙江省杭州市富阳区银湖街道富闲路9号银湖创新中心6号12层1234室
          </p>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="footer-divider"></div>
      <!-- 底部版权备案信息 -->
      <div class="footer-copyright">
        <img src="../assets/jhui.png" alt="" />
        <h4 style="cursor: pointer" @click="toBeian" class="beian">
          备案号：浙ICP备2026025477号-1
        </h4>

        &nbsp;Copyright2016-{{ year }} 杭州笑口杏信息科技有限公司 &nbsp;All Rights Reserved
        杭州笑口杏信息科技有限公司 版权所有
      </div>
    </div>
  </div>
</template>
<script>
import { logout } from "../utils/login";
import { mapState } from "vuex";
export default {
  name: "topHeader",
  components: {},
  data() {
    return {
      headerList: [
        {
          label: "首页",
          path: "/",
        },
        {
          label: "广告策划",
          path: "/advertisement",
        },
        {
          label: "企业咨询",
          path: "/consult",
        },
        {
          label: "数字内容制作",
          path: "/digit",
        },
        {
          label: "系统平台搭建",
          path: "/platform",
        },
        {
          label: "关于我们",
          path: "/about",
        },
      ],
       adminList: [
         {
          label: "首页",
          path: "/",
        },
        {
          label: "广告策划审核",
          path: "/advertisementRecords",
        },
        {
          label: "企业咨询审核",
          path: "/consultRecords",
        },
        {
          label: "数字内容制作审核",
          path: "/digitRecords",
        },
        {
          label: "系统平台搭建审核",
          path: "/platformRecords",
        },
        {
          label: "用户审核",
          path: "/userRecords",
        },
      ],

      isLoad: false,
      logon: {},
      show: false,
      active: 0,
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState({
      activeName: (state) => state.activeName,
    }),
  },
  methods: {
    toBeian() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    handleLogin() {
      this.$router.push("/login");
    },
    handlePublish() {
      if (!this.isLoad) {
        this.$message.warning("请先登录帐号!");
        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
        return;
      }
      this.$store.commit("SET_ACTIVE", -1);
      this.$router.push("/publish");
    },
    handleLink(path, index) {
      this.$store.commit("SET_ACTIVE", index);
      this.$router.push(path);
    },
    showElement() {
      this.show = true;
    },
    hideElement() {
      this.show = false;
    },
    handleLogout() {
      logout().then((res) => {
        localStorage.removeItem("loginstate");
        this.$router.push("/login");
      });
    },
  },
  created() {
    try {
      this.logon = JSON.parse(localStorage.getItem("loginstate")) || {};
    } catch (error) {
      this.logon = {};
      localStorage.removeItem("loginstate");
    }
    if (this.logon.accessToken) {
      this.isLoad = true;
    }
  },
};
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.common {
  width: 100%;
  h2 {
    margin: 68px auto 44px;
    font-size: 47px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 77px;
  }
  &-top {
    .normal();
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding: 0 37px 0 100px;
    background: #141414;
    &-avatar {
      width: 80px;
      height: 40px;
    }
    &-title {
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #f9c92e;
      padding-top: 20px;
    }
    &-header {
      .normal();
      &-left {
        .normal();
        .tab-container {
          display: flex;
          align-items: center;
          .tab-item {
            position: relative;
            margin-right: 37px;
            cursor: pointer;
            span {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              color: #fff;
              display: inline-block;
            }
            .tab-underline {
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 100%;
              height: 7px;
              background: #f9c92e;
              transition: all 0.3s ease;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      &-right {
        .normal();
        &-bottom {
          width: 120px;
          height: 52px;
          border-radius: 8px;
          .normal();
          justify-content: center;
          cursor: pointer;
          margin: 20px 0;
        }
        .bottom1 {
          width: 151px;
          height: 55px;
          border-radius: 5px;
          border: 1px solid #d4af37;
          color: #f9c92e;
          // .fontdemo("PingFangSC,PingFang SC", 500, #f9c92e);
        }
        .bottom2 {
          width: 151px;
          height: 55px;
          border-radius: 5px;
          border: 1px solid #d4af37;
          margin-right: 20px;
          margin-left: 102px;
          color: #f9c92e;
        }
        &-user {
          padding: 20px 0;
          height: 52px;
          .normal();
          margin-left: 0px;
          position: relative;
          cursor: pointer;
          .avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
          }

          .count {
            margin: 0 20px 0 20px;
            .fontdemo(16px, "PingFangSC,PingFang SC", 600, #FFF);
            text-align: left;
          }
          p {
            margin: 0;
          }
          &-toptip {
            width: 131px;
            padding: 13px 10px;
            background: #ffffff;
            box-shadow: 0px 4px 20px 0px #fff;
            border-radius: 12px;
            box-sizing: border-box;
            position: absolute;
            top: 80px;
            right: 0;
            z-index: 99;
            p {
              .fontdemo(14px, "PingFangSC,PingFang SC", 600, rgba(0,0,0,0.85));
              border-bottom: 1px solid #c7c7cc;
              padding-bottom: 13px;
            }
            span {
              .fontdemo(14px, "PingFangSC,PingFang SC", 500, #808080);
              padding-top: 13px;
              display: block;
            }
          }
        }
      }
    }
  }
  /* 重写后的footer样式，1:1匹配设计图 */
  &-footer {
    width: 100%;
    background: #0a0a0a;
    box-sizing: border-box;
    padding: 80px 120px 40px;
    border-top: 1px dashed rgba(100, 120, 180, 0.3);
    font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont,
      sans-serif;

    .footer-main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 1400px;
      margin: 0 auto 60px;

      .footer-logo {
        .normal();
        gap: 20px;

        .footer-logo-img {
          width: 187px;
          height: auto;
          filter: brightness(0) saturate(100%) invert(82%) sepia(76%)
            saturate(749%) hue-rotate(1deg) brightness(106%) contrast(102%);
        }

        .footer-logo-text {
          h2 {
            .fontdemo(36px, "PingFangSC,PingFang SC", 600, #F9C92E);
            margin: 0 0 8px 0;
            line-height: 1.2;
          }
          p {
            .fontdemo(18px, "PingFangSC,PingFang SC", 400, #F9C92E);
            margin: 0;
            opacity: 0.9;
            line-height: 1.2;
          }
        }
      }

      .footer-contact {
        text-align: left;

        h3 {
          .fontdemo(28px, "PingFangSC,PingFang SC", 600, #ffffff);
          margin: 0 0 24px 0;
          line-height: 1.2;
        }

        p {
          .fontdemo(18px, "PingFangSC,PingFang SC", 400, rgba(255,255,255,0.7));
          margin: 0 0 16px 0;
          line-height: 1.5;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .footer-divider {
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.1);
      max-width: 1400px;
      margin: 0 auto 30px;
    }

    .footer-copyright {
      .fontdemo(16px, "PingFangSC,PingFang SC", 400, rgba(255,255,255,0.5));
      text-align: center;
      line-height: 1.5;
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
  }
}
/deep/ .el-tabs__nav-wrap {
  padding: 0 10px;
}
/deep/ .el-tabs__item {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #242929;
  line-height: 25px;
  display: flex;
  align-items: center;
}
/deep/ .el-tabs__nav-wrap {
  padding: 0;
  padding-right: 37px;
}
/deep/ .is-active {
  color: #000000 !important;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__header {
  margin: 0;
}

.beian:hover {
  color: #F9C92E;
}
</style>
